import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlbumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"album"}/>
}
